export const UPDATE_PERSONAL_DATA_TRACKING = 'UPDATE_PERSONAL_DATA_TRACKING';
export const UPDATE_PERSONAL_DATA_TRACKING_RESULT = 'UPDATE_PERSONAL_DATA_TRACKING_RESULT';

interface UpdatePersonalDataTrackingArgs {
  userId: string;
  optOutDate: string;
}

interface UpdatePersonalDataTrackingAction {
  type: typeof UPDATE_PERSONAL_DATA_TRACKING;
  payload: UpdatePersonalDataTrackingArgs;
}

export const updatePersonalDataTracking = ({
  userId,
  optOutDate,
}: UpdatePersonalDataTrackingArgs): UpdatePersonalDataTrackingAction => ({
  type: UPDATE_PERSONAL_DATA_TRACKING,
  payload: {
    userId,
    optOutDate,
  },
});

interface UpdatePersonalDataTrackingResultArgs {
  open: boolean;
  success: boolean;
  // result/error are opaque values passed straight through to the reducer
  result: unknown;
  error: unknown;
}

interface UpdatePersonalDataTrackingResultAction {
  type: typeof UPDATE_PERSONAL_DATA_TRACKING_RESULT;
  payload: UpdatePersonalDataTrackingResultArgs;
}

export const updatePersonalDataTrackingResult = ({
  open,
  success,
  result,
  error,
}: UpdatePersonalDataTrackingResultArgs): UpdatePersonalDataTrackingResultAction => ({
  type: UPDATE_PERSONAL_DATA_TRACKING_RESULT,
  payload: {
    open,
    success,
    result,
    error,
  },
});
